import { doc, getDoc } from 'firebase/firestore';

import { type StripeV2Plan } from '@chartai/utils';

import { getFirebaseDb } from '../app';

interface StripePlansDoc {
  plans: StripeV2Plan[];
  v1PriceIds: string[];
}

export async function fetchStripePlans(): Promise<StripePlansDoc> {
  const db = getFirebaseDb();
  const snap = await getDoc(doc(db, 'stripe_products', 'plans'));
  if (!snap.exists()) {
    return { plans: [], v1PriceIds: [] };
  }
  const data = snap.data();
  return {
    plans: Array.isArray(data['plans']) ? (data['plans'] as StripeV2Plan[]) : [],
    v1PriceIds: Array.isArray(data['v1PriceIds']) ? (data['v1PriceIds'] as string[]) : [],
  };
}
